import React from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { getPlatformDisplayName } from 'utils/platformDisplayNames'
import { generatePath, useHistory } from 'react-router-dom'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { BRAND_PLAN_PATH } from 'paths'
import Styles from './SwitchPlatformNotice.module.scss'
import { useAutopilotLimits } from 'hooks/useAutopilotLimits'

interface SwitchPlatformNoticeProps {
  fromPlatform: ExternalIntegrationEnum
  toPlatform: ExternalIntegrationEnum
  postsPerBatch?: number
  onSwitchPlatform: () => void
}
const POSTS_PER_BATCH_DEFAULT = 4

export const SwitchPlatformNotice = ({
  fromPlatform,
  toPlatform,
  postsPerBatch = POSTS_PER_BATCH_DEFAULT,
  onSwitchPlatform,
}: SwitchPlatformNoticeProps) => {
  const { closeModal } = useModals()
  const history = useHistory()
  const workspaceId = useCurrentWorkspaceId()
  const { maxPostsPerChannel } = useAutopilotLimits()

  const fromPlatformName = getPlatformDisplayName(fromPlatform)
  const toPlatformName = getPlatformDisplayName(toPlatform)
  const postCount = Math.min(postsPerBatch, maxPostsPerChannel)

  const handleSeeContentPlan = () => {
    closeModal()
    history.push(generatePath(BRAND_PLAN_PATH, { workspaceId }))
  }

  return (
    <Modal.Root size="sm">
      <Modal.Header title={`Switch to ${toPlatformName}?`} />
      <Modal.Content>
        <div className={Styles.content}>
          <div className={Styles.consequences}>
            <Heading level={4}>If you switch:</Heading>
            <ul className={Styles.consequencesList}>
              <li>
                <Text>{fromPlatformName} integration will be removed</Text>
              </li>
              <li>
                <Text>Your blog posts will be rescheduled to auto-post on {toPlatformName}</Text>
              </li>
              <li>
                <Text>
                  {toPlatformName} will start with {postCount} posts per batch in your Content Plan (you can adjust
                  anytime)
                </Text>
              </li>
            </ul>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Keep Current
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.rightActions}>
            <Button size="lg" variant="secondary" onPress={handleSeeContentPlan}>
              See Content Plan
            </Button>
            <Button size="lg" variant="primary" onPress={onSwitchPlatform}>
              Switch Platform
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
